import { PainQuestionType } from "../types.js";
const initialPainDetailsData = {
  painDescription: void 0,
  painLocalization: void 0,
  painOccurence: void 0,
  painSeverity: void 0,
  sinceWhenPainOccurs: void 0,
  temperatureSensitivity: void 0
};
const translations = {
  titleText: "booking-process_pain-treatment_details_title",
  hintText: "booking-process_pain-treatment_details_hint",
  buttonText: "booking-process_pain-treatment_details_CTA"
};
const questions = [
  {
    label: "booking-process_pain-treatment_details_question-1",
    type: PainQuestionType.RADIO,
    key: "sinceWhenPainOccurs",
    answers: [
      {
        label: "pain_form_answer_1-3",
        value: "1-3days"
      },
      {
        label: "pain_form_answer_4-7",
        value: "4-7days"
      },
      {
        label: "pain_form_answer_8-14",
        value: "8-14days"
      },
      {
        label: "pain_form_answer_14",
        value: ">14days"
      }
    ]
  },
  {
    label: "booking-process_pain-treatment_details_question-2",
    type: PainQuestionType.RADIO,
    key: "painDescription",
    answers: [
      {
        label: "pain_form_answer_throbbing",
        value: "throbbing"
      },
      {
        label: "pain_form_answer_pressing",
        value: "pressing"
      },
      {
        label: "pain_form_answer_pulling",
        value: "pulling"
      },
      {
        label: "pain_form_answer_stinging",
        value: "stinging"
      }
    ]
  },
  {
    label: "booking-process_pain-treatment_details_question-3",
    type: PainQuestionType.SLIDER,
    key: "painSeverity",
    answers: [
      {
        label: "pain_form_answer_very-light",
        value: "veryLight"
      },
      {
        label: "pain_form_answer_light",
        value: "light"
      },
      {
        label: "pain_form_answer_medium",
        value: "medium"
      },
      {
        label: "pain_form_answer_strong",
        value: "strong"
      },
      {
        label: "pain_form_answer_very-strong",
        value: "veryStrong"
      }
    ]
  },
  {
    label: "booking-process_pain-treatment_details_question-4",
    type: PainQuestionType.RADIO,
    key: "temperatureSensitivity",
    answers: [
      {
        label: "pain_form_answer_heat",
        value: "heat"
      },
      {
        label: "pain_form_answer_cold",
        value: "cold"
      },
      {
        label: "pain_form_answer_none",
        value: "none"
      }
    ]
  },
  {
    label: "booking-process_pain-treatment_details_question-5",
    type: PainQuestionType.RADIO,
    key: "painOccurence",
    answers: [
      {
        label: "pain_form_answer_day",
        value: "day"
      },
      {
        label: "pain_form_answer_night",
        value: "night"
      },
      {
        label: "pain_form_answer_eating",
        value: "eating"
      },
      {
        label: "pain_form_answer_spontaneously",
        value: "spontaneously"
      },
      {
        label: "pain_form_answer_always",
        value: "always"
      }
    ]
  },
  {
    label: "booking-process_pain-treatment_details_question-6",
    type: PainQuestionType.RADIO,
    key: "painLocalization",
    answers: [
      {
        label: "pain_form_answer_teeth",
        value: "teeth"
      },
      {
        label: "pain_form_answer_gums",
        value: "gums"
      },
      {
        label: "pain_form_answer_temporomandibular-joint",
        value: "temporomandibularJoint"
      },
      {
        label: "pain_form_answer_not-clearly-localizable",
        value: "notClearlyLocalizable"
      }
    ]
  }
];
export {
  initialPainDetailsData,
  questions,
  translations
};
